var ProductConfigurationFilterItem = function (attribute) {
    var that = this;

    that.IsExtension = attribute.IsExtension();
    that.IsGrammage = attribute.SelectedObjectValueId() < 0;

    that.AttributeId = attribute.AttributeId();
    that.ObjectValueId = attribute.SelectedObjectValueId();

    that.IsCustomValue = attribute.CustomValue.IsCustomValueOptionSelected();
    that.CustomValue = attribute.CustomValue.CustomValue();
    
    that.IsCustomFormat = attribute.CustomFormat.IsCustomFormatSelected();
    that.CustomLength = attribute.CustomFormat.Length();
    that.CustomWidth = attribute.CustomFormat.Width();

    // not required but for debugging purspose
    that.Description = attribute.LocalizationKey();
};